export enum RefinementFlag {
  Hidden = "Hidden"
}
